import * as React from "react";
import styled from "styled-components";
import CallToActionButton from "components/shared/buttons/CallToActionButton";
import Link from "next/link";
import {
  CtaType,
  useRecordCtaClicked,
} from "hooks/analytics/useRecordCtaClicked";
import { baseUrl } from "services/shared/Environment";

const HeroDesktopTextContainer = styled.div.attrs({
  className:
    "mt-6 hidden lg:flex flex-col align-center text-center items-center",
})`
  height: 400px;
  min-width: 450px;
  text-align: center;
`;

const HeroMobileTextContainer = styled.div.attrs({
  className:
    "lg:hidden h-auto px-4 pb-0 flex flex-col items-center text-center w-full mx-auto",
})`
  max-width: 500px;
`;

const Hero = styled.div.attrs({
  className:
    "container h-full py-4 lg:pt-12 px-4 flex items-start justify-around mt-20 mb-10",
})`
  max-width: 900px;
`;

const HeroTitle: any = styled.h1.attrs<any>({
  className: "text-6xl font-bold leading-none m-0",
})`
  font-family: ${(props) => props.theme.fonts.karma};
  margin-bottom: 0px;
`;

const HeroMobileTitle = styled<any>(HeroTitle)`
  text-align: center;
  font-size: 46px;
`;

const HeroSubtitle = styled.h2.attrs({
  className: "text-xl font-normal mx-0 my-6 leading-snug",
})`
  font-family: ${(props) => props.theme.fonts.poppins};
  color: #727272;

  a {
    color: rgb(38, 79, 149) !important;
    text-decoration: underline;
    :visited {
      color: rgb(38, 79, 149) !important;
    }
    :hover {
      cursor: pointer;
    }
  }
`;

const HeroMobileSubtitle = styled<any>(HeroSubtitle)`
  text-align: center;
`;

const HeroSignupButton = styled<any>(CallToActionButton)`
  width: 250px;
  padding: 15px 20px;
  margin: 10px 0;
  font-size: 15px;
`;

const HeroDesktopText = () => {
  const recordCtaClicked = useRecordCtaClicked();
  const heroCtaButtonText = "Try for free";
  const heroCtaButtonHrefPath = "/subscribe";

  const recordHeroCtaClicked = () => {
    recordCtaClicked({
      ctaType: CtaType.button,
      ctaText: heroCtaButtonText,
      ctaDestinationUrl: `${baseUrl()}${heroCtaButtonHrefPath}`,
    });
  };

  return (
    <HeroDesktopTextContainer>
      <HeroTitle>
        The South Asian stories <br /> you need to know
      </HeroTitle>
      <HeroSubtitle>
        Smart journalism on South Asia and
        <br />
        South Asians around the world.
      </HeroSubtitle>
      <Link href={heroCtaButtonHrefPath}>
        <HeroSignupButton
          onClick={() => {
            recordHeroCtaClicked();
          }}
        >
          Try for free ➔
        </HeroSignupButton>
      </Link>
      <HeroSubtitle></HeroSubtitle>
    </HeroDesktopTextContainer>
  );
};

const HeroMobileText = () => (
  <HeroMobileTextContainer>
    <HeroMobileTitle>The South Asian stories you need to know</HeroMobileTitle>
    <HeroMobileSubtitle>
      Smart journalism on South Asia and South Asians around the world.
    </HeroMobileSubtitle>
    <Link href="/subscribe">
      <HeroSignupButton>Try for free ➔</HeroSignupButton>
    </Link>
    <HeroMobileSubtitle></HeroMobileSubtitle>
  </HeroMobileTextContainer>
);

export default () => (
  <Hero>
    <HeroDesktopText />
    <HeroMobileText />
  </Hero>
);
